import React from "react"

import { SchoolyearEndScreenContent } from "./ScreenContent"

export const SchoolyearEndProtectedScreenContent = () => <SchoolyearEndScreenContent />
